<script setup lang="ts">
import { carNumberModel, VCarNumber } from '@/entities/v-car-number'
import { MtdButton } from '@paygine/mtd-uikit'
import { useTemplateRef } from 'vue'
const props = defineProps<{
    externalError: carNumberModel.ExternalError
    isLoading: boolean
}>()

const emit = defineEmits<{
    'carNumber:update': [data: { country: string; grn: string }]
    'carNumber:add': []
}>()

const model = defineModel<boolean>({ default: false })

const carNumberRef = useTemplateRef<InstanceType<typeof VCarNumber>>('car-number')

defineExpose({
    validate: () => carNumberRef.value?.validate(),
})
</script>

<template>
    <div
        class="add-transport"
        v-if="model"
    >
        <VCarNumber
            ref="car-number"
            :enable-variants-select="true"
            :external-error="externalError"
            @car-number:update="(data) => emit('carNumber:update', data)"
        />

        <div class="add-transport__button-container">
            <MtdButton
                class="mt-16"
                variant="main-secondary"
                :is-loading="isLoading"
                type="button"
                @click="model = false"
                >Отмена</MtdButton
            >

            <MtdButton
                type="button"
                variant="main"
                class="transport-modal__add-button"
                :is-loading="isLoading"
                @click="emit('carNumber:add')"
                >Сохранить</MtdButton
            >
        </div>
    </div>
</template>

<style lang="scss">
.add-transport {
    &__button-container {
        display: flex;
        gap: 12px;
    }
}
</style>
